/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Calendar_Sync_CooldownInputs */

const cs_calendar_sync_cooldown = /** @type {(inputs: Calendar_Sync_CooldownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Před další synchronizací počkejte ${i?.seconds} s`)
};

const en_calendar_sync_cooldown = /** @type {(inputs: Calendar_Sync_CooldownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wait ${i?.seconds}s before syncing again`)
};

/**
* | output |
* | --- |
* | "Wait {seconds}s before syncing again" |
*
* @param {Calendar_Sync_CooldownInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_sync_cooldown = /** @type {((inputs: Calendar_Sync_CooldownInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Sync_CooldownInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_sync_cooldown(inputs)
	return cs_calendar_sync_cooldown(inputs)
});